import styled from "@emotion/styled";
import { ImpactType } from "@ecologi/shared";
import { mobileDown } from "../theme/ecologi-breakpoints";
import useMedia from "react-use/lib/useMedia";
import { useState } from "react";
import { FilterIcon } from "./FilterIcon";
import { FilterButton } from "./ImpactFilterButton";
import { Typography } from "../Typography";

const FilterBar = styled.div`
  position: relative;

  /* Make space for the filter drop control above the filter buttons on smaller screens */
  @media ${(props) => props.theme.bp.wideDesktopDown} {
    padding-top: 60px;
  }

  /* Ensure there is always space for absolutely positioned filter drop control */
  min-height: 72px;
`;

const FilterDropControl = styled.button`
  display: flex;
  gap: 8px;
  align-items: center;
  cursor: pointer;
  border-radius: 30px;
  border: none;
  background: none;
  :focus-visible {
    outline: ${(props) => `2px solid ${props.theme.colors.forest}`};
    outline-offset: 2px;
  }

  position: absolute;
  top: 24px;
  right: 40px;

  @media ${(props) => props.theme.bp.tabletDown} {
    top: 14px;
    right: 24px;
  }
`;

const FilterButtons = styled.div`
  display: flex;
  justify-content: center;
  padding: 24px 0;
  gap: 8px;
  flex-wrap: wrap;
`;

const TYPES = {
  [ImpactType.TREES]: {
    text: "Reforestation",
  },
  [ImpactType.CARBON_OFFSETS]: {
    text: "Carbon avoidance",
  },
  [ImpactType.CARBON_REMOVAL]: {
    text: "Carbon removal",
  },
  [ImpactType.HABITAT_RESTORATION]: {
    text: "Habitat restoration",
  },
};

export const ImpactShopFilterBar = ({
  impactType,
  setImpactType,
}: {
  impactType: ImpactType | null;
  setImpactType: (impactType: ImpactType | null) => void;
}) => {
  const isMobile = useMedia(mobileDown);
  const [showFilters, setShowFilters] = useState(isMobile ? false : true);
  return (
    <FilterBar>
      <FilterDropControl onClick={() => setShowFilters(!showFilters)}>
        <Typography use="body3">Filter</Typography>
        <FilterIcon filterSelected={impactType !== null} />
      </FilterDropControl>
      {showFilters && (
        <FilterButtons>
          <FilterButton
            impactType={null}
            selected={impactType === null}
            onClick={() => setImpactType(null)}
          >
            All
          </FilterButton>
          {Object.entries(TYPES).map(([key, value]) => {
            return (
              <FilterButton
                key={key}
                selected={impactType === key}
                impactType={key as ImpactType}
                onClick={() => setImpactType(key as ImpactType)}
              >
                {value.text}
              </FilterButton>
            );
          })}
        </FilterButtons>
      )}
    </FilterBar>
  );
};
